// @ts-nocheck
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Box } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
  },
  hidden: {
    display: 'none',
  },
}));

function TabPanel(props) {
  const classes = useStyles();

  const { id, index, currentIndex, children } = props;

  return (
    <Box
      id={id}
      className={clsx(classes.root, {
        [classes.hidden]: index !== currentIndex,
      })}
    >
      {children}
    </Box>
  );
}

TabPanel.defaultProps = {
  id: undefined,
};

TabPanel.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
};

export default TabPanel;
